module.exports = __webpack_public_path__ + "assets/media/morning.b5401312.mp3";